import React, { useEffect, useRef, useState } from 'react'

import TussenPersonen from './TussenPersonen'

import { DISCOUNTS } from '../App'
import { ReactComponent as CloseIcon } from '../close.svg'
import { ReactComponent as FilterIcon } from '../filter.svg'
import basiqLogo from '../logo-basiq.svg'
import basiqSelectLogo from '../logo-basiq-select.svg'
import classiqLogo from '../logo-classiq-white.svg'
import classiqSelectLogo from '../logo-classiq-select.svg'
import genericLogo from '../logo-generic.svg'
import InterestTable from './InterestTable'

export const PRODUCT_TYPES = {
  BASIQ_SELECT: 'BASIQ_SELECT',
  BASIQ: 'BASIQ',
  CLASSIQ_SELECT: 'CLASSIQ_SELECT',
  CLASSIQ: 'CLASSIQ',
  GENERIQ: 'GENERIQ',
}

// Products that never carry the Vastgoed Belang discount (no discount field,
// no discount message, and the discount value is not applied to their rates).
const NO_DISCOUNT_PRODUCTS = [PRODUCT_TYPES.GENERIQ, PRODUCT_TYPES.BASIQ_SELECT, PRODUCT_TYPES.CLASSIQ_SELECT]

// Tab ids of the Select products (BasiQ Select, ClassiQ Select).
const SELECT_TAB_IDS = ['1', '3']

const CLASSIQ_RVPS = {
  '1 maand': 0,
  '1 jaar': 0.05,
  '2 jaar': 0.1,
  '3 jaar': 0.1,
  '3 + 2 jaar (Solid-BreaQ)': 0.15,
  '5 jaar': 0.15,
}

const MAX_GENERIQ_LTV = 65
const MAX_BASIQ_LTV = 85
const MAX_CLASSIQ_LTV = 85
const MAX_BASIQ_SELECT_LTV = 85
const MAX_CLASSIQ_SELECT_LTV = 85

// The taller "SELECT" logos get a bit more height so the wordmark isn't shrunk.
const TAB_LOGO_HEIGHT = '28px'
const SELECT_TAB_LOGO_HEIGHT = '38px'

const Tabs = (props) => {
  const formRef = useRef()
  const [filterActive, setFilterActive] = useState(false)
  const [geschatteMarktwaarde, setGeschatteMarktwaarde] = useState()
  const [gewensteHypotheek, setGewensteHypotheek] = useState()
  const [filterLTV, setFilterLTV] = useState()
  const [noMortgagePossible, setNoMortgagePossible] = useState()
  const [tabs, setTabs] = useState([
    {
      id: 1,
      tabTitle: <img src={basiqSelectLogo} style={{ pointerEvents: 'none', height: SELECT_TAB_LOGO_HEIGHT }} alt="Basiq Select" />,
      content: ['Loading...'],
    },
    {
      id: 2,
      tabTitle: <img src={basiqLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Basiq" />,
      content: 'Loading...',
    },
    {
      id: 3,
      tabTitle: <img src={classiqSelectLogo} style={{ pointerEvents: 'none', height: SELECT_TAB_LOGO_HEIGHT }} alt="Classiq Select" />,
      content: 'Loading...',
    },
    {
      id: 4,
      tabTitle: <img src={classiqLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Classiq" />,
      content: 'Loading...',
    },
    {
      id: 5,
      tabTitle: <img src={genericLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Generiq" />,
      content: 'Loading...',
    },
  ])
  const [filterLoading, setFilterLoading] = useState(false)
  const [aanvragenActive, setAanvragenActive] = useState(false)
  const [selectedRate, setSelectedRate] = useState({})
  // const [filterInterestsActive, setFilterInterestsActive] = useState(false);

  const currentTab = props.currentTab

  const handleChangeDiscount = (e) => {
    props.onDiscountChange(e.target.value)
  }

  const handleFilterClick = (e) => {
    props.onFilterClick()
    setFilterActive(!filterActive)
  }

  const interestTableGenerator = (uniq, interests, filtered, productType) => {
    setNoMortgagePossible(false)

    if (filtered && filterLTV > 85) {
      setNoMortgagePossible(true)
      setFilterLoading(false)
      return
    }

    if (productType === PRODUCT_TYPES.GENERIQ && filtered && filterLTV > 65) {
      setNoMortgagePossible(true)
      return
    }

    if (filtered && currentTab !== '5' && uniq && filterLTV >= 81 && filterLTV <= 85) {
      props.onTabChange('4')
    }

    if (filtered && productType === PRODUCT_TYPES.BASIQ && filterLTV > 85) {
      setNoMortgagePossible(true)
      return
    }

    return (
      <InterestTable
        interests={interests}
        uniq={uniq}
        filtered={filtered}
        productType={productType}
        discountValue={NO_DISCOUNT_PRODUCTS.includes(productType) ? 0 : props.discountValue}
        onClick={({ interestItem, interestKey, interestValue, val }) => {
          console.log('selected: ', interestItem, interestKey, interestValue, val)
          setAanvragenActive(true)
          setSelectedRate({
            rate: interestItem,
            key: interestKey,
            interestValue,
            discount: NO_DISCOUNT_PRODUCTS.includes(productType) ? 0 : DISCOUNTS[props.discount],
            label: val.label,
            uniq,
            productType,
            ltv: filterLTV,
            gewensteHypotheek,
            geschatteMarktwaarde,
          })
        }}
      />
    )
  }

  const filteredItems = (interests) => {
    const filteredLtv = []
    interests?.ltvs?.forEach((ltvItem) => {
      const ltv = parseInt(ltvItem.label.replace('%', ''))
      if (parseFloat(filterLTV) <= ltv) {
        filteredLtv.push(ltvItem)
      }
    })

    const filteredRvps = interests?.rvps?.map((rvpItem) => {
      return {
        ...rvpItem,
        interests: rvpItem.interests.filter((interestItem) => {
          return interestItem.ltvId === filteredLtv[0]?.id
        }),
      }
    })

    const filteredInterests = JSON.parse(JSON.stringify(interests))
    filteredInterests.ltvs = [filteredLtv[0]]

    filteredInterests.rvps = filteredRvps

    return filteredInterests
  }

  const filteredClassiqItems = (interests) => {
    const classiqRvps = interests?.rvps
      ?.filter((rvpItem) => {
        return Object.keys(CLASSIQ_RVPS).includes(rvpItem.label)
      })
      .map((rvpItem) => {
        return JSON.parse(JSON.stringify(rvpItem))
      })

    for (let i = 0; i < classiqRvps.length; i++) {
      classiqRvps[i].interests = classiqRvps[i].interests.map((interest) => {
        if (Object.keys(CLASSIQ_RVPS).includes(classiqRvps[i].label)) {
          interest.value += CLASSIQ_RVPS[classiqRvps[i].label]
        }
        return interest
      })
    }

    const filteredInterests = JSON.parse(JSON.stringify(interests))
    filteredInterests.ltvs = interests?.ltvs

    filteredInterests.rvps = classiqRvps

    return filteredInterests
  }

  const renderInterests = (filterAction, interests) => {
    if (props.isLoading) {
      setTabs([
        {
          id: 1,
          tabTitle: <img src={basiqSelectLogo} style={{ pointerEvents: 'none', height: SELECT_TAB_LOGO_HEIGHT }} alt="Basiq Select" />,
          content: 'Laden...',
        },
        {
          id: 2,
          tabTitle: <img src={basiqLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Basiq" />,
          content: 'Laden...',
        },
        {
          id: 3,
          tabTitle: <img src={classiqSelectLogo} style={{ pointerEvents: 'none', height: SELECT_TAB_LOGO_HEIGHT }} alt="Classiq Select" />,
          content: 'Laden...',
        },
        {
          id: 4,
          tabTitle: <img src={classiqLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Classiq" />,
          content: 'Laden...',
        },
        {
          id: 5,
          tabTitle: <img src={genericLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Generiq" />,
          content: 'Laden...',
        },
      ])
      return
    }

    if (!interests?.ltvs) {
      return null
    }

    // Always show all 5 tabs: BasiQ Select, BasiQ, ClassiQ Select, ClassiQ, GeneriQ.
    // Select products read directly from their own endpoint (no ClassiQ transform).
    setTabs([
      {
        id: 1,
        tabTitle: <img src={basiqSelectLogo} style={{ pointerEvents: 'none', height: SELECT_TAB_LOGO_HEIGHT }} alt="Basiq Select" />,
        content:
          filterAction && filterLTV > MAX_BASIQ_SELECT_LTV
            ? `BasiQ Select is enkel mogelijk bij een LTV tot ${MAX_BASIQ_SELECT_LTV}%`
            : interestTableGenerator(
              false,
              filterAction ? filteredItems(interests) : interests,
              filterAction,
              PRODUCT_TYPES.BASIQ_SELECT,
            ),
      },
      {
        id: 2,
        tabTitle: <img src={basiqLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Basiq" />,
        content:
          filterAction && filterLTV > MAX_BASIQ_LTV
            ? `BasiQ is enkel mogelijk bij een LTV tot ${MAX_BASIQ_LTV}%`
            : interestTableGenerator(
              false,
              filterAction ? filteredItems(interests) : interests,
              filterAction,
              PRODUCT_TYPES.BASIQ,
            ),
      },
      {
        id: 3,
        tabTitle: <img src={classiqSelectLogo} style={{ pointerEvents: 'none', height: SELECT_TAB_LOGO_HEIGHT }} alt="Classiq Select" />,
        content:
          filterAction && filterLTV > MAX_CLASSIQ_SELECT_LTV
            ? `ClassiQ Select is enkel mogelijk bij een LTV tot ${MAX_CLASSIQ_SELECT_LTV}%`
            : interestTableGenerator(
              false,
              filterAction ? filteredItems(interests) : interests,
              filterAction,
              PRODUCT_TYPES.CLASSIQ_SELECT,
            ),
      },
      {
        id: 4,
        tabTitle: <img src={classiqLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Classiq" />,
        content:
          filterAction && filterLTV > MAX_CLASSIQ_LTV
            ? `ClassiQ is enkel mogelijk bij een LTV tot ${MAX_CLASSIQ_LTV}%`
            : interestTableGenerator(
              false,
              filterAction ? filteredItems(filteredClassiqItems(interests)) : filteredClassiqItems(interests),
              filterAction,
              PRODUCT_TYPES.CLASSIQ,
            ),
      },
      {
        id: 5,
        tabTitle: <img src={genericLogo} style={{ pointerEvents: 'none', height: TAB_LOGO_HEIGHT }} alt="Generiq" />,
        content:
          filterAction && filterLTV > MAX_GENERIQ_LTV
            ? `Generiq is enkel mogelijk bij een LTV tot ${MAX_GENERIQ_LTV}%`
            : interestTableGenerator(
              false,
              filterAction ? filteredItems(interests) : interests,
              filterAction,
              PRODUCT_TYPES.GENERIQ,
            ),
      },
    ])
  }

  useEffect(() => {
    renderInterests(false, props.interests)
  }, [props.interests, props.discountValue, props.isLoading])

  const handleTabClick = (e) => {
    props.onTabChange(e.target.id)
  }

  const calculateLTV = (e) => {
    console.log('onChange={(e) => calculateLTV(e)}', gewensteHypotheek)
    if ('geschatteMarktwaarde' === e.id) {
      setGeschatteMarktwaarde(e.value)
      if (gewensteHypotheek > 0) {
        const ltvVal = ((gewensteHypotheek / e.value) * 100).toFixed()
        setFilterLTV(ltvVal)
      }
    } else {
      setGewensteHypotheek(e.value)
      if (geschatteMarktwaarde) {
        const ltvVal = ((e.value / geschatteMarktwaarde) * 100).toFixed()
        setFilterLTV(ltvVal)
      }
    }
  }

  const resetFilter = () => {
    formRef.current.reset()
    setFilterLTV(false)
    renderInterests(false, props.interests)
    setGeschatteMarktwaarde(0)
    setGewensteHypotheek(0)
    props.onTabChange('1')
  }

  const submitFilterForm = (e) => {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

    e.preventDefault()
    setFilterLoading(true)

    setTimeout(() => {
      renderInterests(true, props.interests)
      setFilterLoading(false)
      if (width < 790) {
        setFilterActive(false)
      }
    }, 1200)
  }

  const interestsDate = new Date(props.interests.startDate)

  return (
    <div className="">
      {!aanvragenActive && (
        <>
          <h3 className="text-3xl font-bold mb-2">Actuele rentetarieven per {interestsDate.toLocaleDateString()}.</h3>
          {!SELECT_TAB_IDS.includes(currentTab) && (
            <p className="mb-8 font-bold warning-message">
              {'' === props.discount &&
                'Voor leden van Vastgoed Belang geldt bij nieuwe aanvragen nog een rentekorting tot wel 0,20%! (m.u.v. variabele rente)'}
              {'INTEREST_10' === props.discount &&
                'In onderstaande rentepercentages is een rentekorting ad 0,10% voor leden van Vastgoed Belang opgenomen.'}
              {'INTEREST_20' === props.discount &&
                'In onderstaande rentepercentages is een rentekorting ad 0,20% voor leden van Vastgoed Belang  opgenomen.'}
            </p>
          )}

          <div className="tab-controls">
            <div>
              <button
                className={`filter-button flex align-middle ${filterActive ? 'active' : ''}`}
                onClick={handleFilterClick}
              >
                <FilterIcon style={{ pointerEvents: 'none', marginTop: 4, marginRight: 4 }} />
                Filter
              </button>
            </div>
            <div className="tabs">
              {tabs.map((tab, i) => (
                <button
                  key={i}
                  id={tab.id}
                  disabled={currentTab === `${tab.id}`}
                  onClick={handleTabClick}
                >
                  {tab.tabTitle}
                </button>
              ))}
            </div>
          </div>
          <div className="flex">
            {filterActive && (
              <div className="filter-content flex-none pr-8 border-r border-white mr-8">
                <div className="flex my-6">
                  <div className="flex-auto"></div>
                  <div className="flex-none">
                    <CloseIcon
                      onClick={() => (setFilterActive(!filterActive), resetFilter())}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
                <div>
                  <form
                    ref={formRef}
                    onSubmit={(e) => submitFilterForm(e)}
                  >
                    {currentTab !== '5' && !SELECT_TAB_IDS.includes(currentTab) && (
                      <div className="mb-4">
                        <label
                          htmlFor="discount"
                          className="block mb-1"
                        >
                          Korting
                        </label>
                        <select
                          id="discount"
                          name="discount"
                          value={props.discount}
                          className="input-border-color h-12 mt-0 block w-full px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
                          onChange={handleChangeDiscount}
                        >
                          <option value="">Geen korting</option>
                          <option value="INTEREST_10">{DISCOUNTS.INTEREST_10}</option>
                          <option value="INTEREST_20">{DISCOUNTS.INTEREST_20}</option>
                        </select>
                      </div>
                    )}
                    <div className="mb-4 ">
                      <label
                        htmlFor="geschatteMarktwaarde"
                        className="block"
                      >
                        Marktwaarde onderpand
                      </label>
                      <div className="mt-1 flex ">
                        <span className="inline-flex items-center px-3 border-0 text-lg bg-primary-80 input-prefix">
                          &euro;
                        </span>
                        <input
                          id="geschatteMarktwaarde"
                          name="geschatteMarktwaarde"
                          type="number"
                          onChange={(e) => calculateLTV(e.target)}
                          onInput={(e) => {
                            if (e.target.validity.rangeUnderflow) {
                              e.target.setCustomValidity('De waarde moet minimaal €100.000 zijn')
                            } else {
                              e.target.setCustomValidity('')
                            }
                          }}
                          defaultValue={geschatteMarktwaarde}
                          autoComplete="geschatteMarktwaarde"
                          placeholder="Marktwaarde"
                          min="100000"
                          className="input-border-color  h-12 mt-0 block w-full px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-4 ">
                      <label
                        htmlFor="gewensteHypotheek"
                        className="block"
                      >
                        Gewenste hypotheek
                      </label>
                      <div className="mt-1 flex flex-col">
                        <div className="flex">
                          <span className="inline-flex items-center px-3 border-0 text-lg bg-primary-80 input-prefix">
                            &euro;
                          </span>
                          <input
                            id="gewensteHypotheek"
                            name="gewensteHypotheek"
                            type="number"
                            autoComplete="gewensteHypotheek"
                            onChange={(e) => calculateLTV(e.target)}
                            onInput={(e) => {
                              if (e.target.validity.rangeUnderflow) {
                                e.target.setCustomValidity('Het gewenste hypotheekbedrag dient minimaal €100.000 te zijn')
                              } else {
                                e.target.setCustomValidity('')
                              }
                            }}
                            defaultValue={gewensteHypotheek}
                            placeholder="Hypotheek"
                            min="100000"
                            className="input-border-color  h-12 mt-0 block w-full px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
                            required
                          />
                        </div>
                        {!!(gewensteHypotheek && gewensteHypotheek < 100000) && (
                          <small className="text-slate-50 leading-tight mt-1">
                            Het gewenste hypotheekbedrag
                            <br /> dient minimaal €100.000 te zijn
                          </small>
                        )}
                      </div>
                    </div>
                    LTV: {filterLTV ? filterLTV + '%' : '-'}
                    <div className="flex justify-end space-x-2 mt-8">
                      <button
                        type="button"
                        onClick={() => resetFilter()}
                        className=" py-1 px-4 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        id="submitFilter"
                        className="focus:outline-none w-100 flex-1 py-3 px-5 shadow-sm text-center text-white bg-secondary-100 hover:bg-primary-300 font-medium disabled:opacity-50 disabled:hover:bg-primary-100"
                      >
                        {filterLoading && (
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            ></path>
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="#1C64F2"
                            ></path>
                          </svg>
                        )}
                        Toepassen
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            <div
              className={
                noMortgagePossible
                  ? 'flex-auto flex justify-center items-center'
                  : 'flex-auto overflow-x-auto overflow-y-hidden h-full table-overflow relative'
              }
            >
              {noMortgagePossible && (
                <div className="text-center m-auto font-medium">
                  {tabs.map((tab, i) => (
                    <div key={i}>{currentTab === `${tab.id}` && <div className="py-3 ">{tab.content}</div>}</div>
                  ))}
                </div>
              )}

              <div className="tab-content ">
                {tabs.map((tab, i) => (
                  <div key={i}>{currentTab === `${tab.id}` && <div className="py-3 ">{tab.content}</div>}</div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      {aanvragenActive && (
        <TussenPersonen
          selectedRate={selectedRate}
          goBack={() => setAanvragenActive(false)}
        />
      )}
    </div>
  )
}

export default Tabs
